import { NgModule, Optional, SkipSelf, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TableSortLink } from '../components/table-sort-link/table-sort-link.component';



export class LeafTableUtilsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    TableSortLink
  ],
  exports: [
    TableSortLink
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
